module.exports = __webpack_public_path__ + "static/media/edinburgh-22.41aeae15.jpg";